<template>
  <div class="page-index flex flex-column jc">
    <div class="main-container">
      <div class="main-top flex jc">
          <img :src="logo" class="logo"/>
          <div class="title flex jc">
          <img :src="title" class="title-img"/>

          </div>
      </div>
      <div class="column flex jc wrap w100">
        <div class="type-item flex flex-column jr " 
          @click="goPath(item.spot)" 
          v-for="(item, index) in config.site" 
          v-if="index<2"
          :key="index">
            <div class="img-cover" :style="`background-image:url(${getPic(item.pic)})`" > </div>
            <div class="txt flex jc end">
              <div class="flex">
                <div class="name ">{{item.name}}</div>
                <span class="arrow iconfont icon-arrow-right"></span>
              </div>
            </div>
            <div class="logo-img-s" v-if="index==1">
              <img :src="logoImg"/>
            </div>
            <!-- <div class="logo-img-s logo-img-s1" v-if="index==0">
              <img :src="logoImg2"/>
            </div> -->
        </div>
      </div>
      <div class="column more-column w100">
        <div class="type-item " v-for="(item, index) in config.site"  v-if="item.full" :key="index" @click="goPath(item.spot,item)" >
          <div class="img-cover" :style="`background-image:url(${getPic(item.pic)})`" > </div>
          <div class="txt flex jc end">
            <div class="name">{{ item.name }}</div>
            <span class="arrow iconfont icon-arrow-right"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import logoImg from "@/assets/images/logo-img.png"
import logoImg2 from "@/assets/images/logo-img2.png"
import logo from "@/assets/images/logo.png"
import title from "@/assets/images/title.png"
import config from '@/config';
export default {
  components:{},
  props:{},
  data(){
    return{
      config,
      logo,
      title,
      logoImg,
      logoImg2
    }
  },
  mounted() {
    this.addCount()
  },
  methods: {
    addCount(){
      this.$api.userApi.getAccount({typeid:1})
    },
    goPath(e,item){
      if(item){
        this.$router.push(item.path+'?spot='+e)
        return
      }
      this.$router.push("/home?spot="+e +"&type=ar")
    },
    getPic(path){
      return require('@/assets/images/'+path)
    }
  },
}
</script>
<style lang="scss" scoped>
  .page-index{
    background: url("~@/assets/images/full-bg.jpg") center center no-repeat;
    background-size: cover;
    width:100vw;
    height:100vh;
    position: relative;
    .main-container{
      width: 75%;
    }
    .type-item{
      // width: calc(50% - 10rem);
      flex: 1;
      margin-right: 20rem;
      box-sizing: border-box;
      position: relative;
      border-radius: 30rem;
      transition: all 0.35s;
      .img-cover{
        width: 100%;
        padding-bottom: calc(100% * 44 / 72);
        position: relative;
        box-sizing: border-box;
        background: center center no-repeat;
        background-size: contain;
      }
      &:last-child{
        margin-right: 0;
      }
      &:hover{
        box-shadow: 0 0 20rem rgba($color: #2583b9, $alpha: 0.7);
        cursor: pointer;
      }
      
      .txt{
        position: absolute;
        width:100%;
        height: 100%;
        box-sizing: border-box;
        padding-bottom: 20rem;
        color: #fff;
        line-height: 27px;
        .arrow{
          font-weight: bold;
          margin-left: 10px;
        }
      }
      .name{
        font-size: 20rem;
        color: #fff;
      }
      
      .logo-img-s{
        position: absolute;
        right: 20rem;
        bottom: 0;
        img{
          width: 80rem;
        }
        &.logo-img-s1{
          right: auto;
          bottom: auto;
          left: -10rem;
          top: -60rem;
        }
      }
    }
    .more-column{
      margin-top: 20rem;
      .type-item{
        position: relative;
        border-radius: 30rem;
        transition: all 0.35s;
        .img-cover{
          width: 100%;
          padding-bottom: calc(100% * 200 / 1480);
          position: relative;
          box-sizing: border-box;
          background: center center no-repeat;
          background-size: contain;
        }
        .txt{
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%,-50%);
          font-size: 20rem;
          color: #fff;
          letter-spacing: 1px;
        }
      }
    }
  }

  .main-top{
    padding-bottom: 20rem;
    position: relative;
    .logo{
      width: 92rem;
      position: absolute;
      left: 0;
      top: -10rem;
    }
    .title{
      .title-img{
        width: 400rem;
      }
    }
  }

  [data-device='pad']{
    .page-index{
      background-size: 125%;
      .main-container{
        width: 80%;
      }
      .column{
        width: 100%;
      }
      .main-top{
        padding-bottom: 10rem;
        .logo{
          width: 30rem;
          top: -4rem;
        }
        .title-img{
          width: 150rem;
        }
      }
      .type-item{
        flex: 1;
        min-width: auto;
        margin-right: 8rem;
        &:last-child{
          margin-right: 0;
        }
        .txt{
          padding-bottom: 8rem;
        }
        .name{
          font-size: 9rem;
        }
        .logo-img-s{
          right: 10rem;
          img{
            width: 30rem;
          }
          &.logo-img-s1{
            left: -10rem;
            top: -30rem;
          }
        }
      }
      .more-column{
        margin-top: 8rem;
        .type-item{
          width: 100%;
          
        }
      }
    }
    
  }
  [data-device='phone']{
    
    .page-index{
      background-size: auto 105%;
      overflow-y:auto;
      height: auto;
      min-height: 100vh;
      .main-container{
        width: 90%;
        padding-bottom: 80rem;
      }
      .main-top{
        padding-bottom: 20rem;
        padding-top: 90rem;
        .logo{
          width: 60rem;
          top: 20rem;
          left: auto;
          right: 0;
        }
        .title-img{
          width: 90%;
        }
      }
      .column{
        flex-direction: column;
        width: 100%;
        gap: 20rem;
      }
      .type-item{
        width: 100%;
        margin-right: 0;
      }
      .more-column{
        .type-item{
          .img-cover{
            background-size: cover;
            padding-bottom: calc(100% * 100 / 315);
            border-radius: 20rem;
          }
          .name{
            font-size: 14rem;
          }
        }
      }
       .logo-img-s img{
        max-width: 60rem;
      }
     
    }
  }


</style>
<style scoped>
  [data-device='phone'] #app{
    height: auto;
  }
</style>